module.exports = __webpack_public_path__ + "static/media/test.5f4713d6.png";